import { Button } from '@/components/ui/button';
import { QuestionnaireSectionProps } from '@/types/questionnaire';
import { useDeleteSectionMutation } from '../hooks/useDeleteSectionMutation';

export function DeleteSectionDialog({
  section,
  onClose,
  onSuccess,
}: {
  section: QuestionnaireSectionProps;
  onClose: () => void;
  onSuccess?: () => void;
}) {
  const { deleteSectionMutation, handleDelete } = useDeleteSectionMutation({
    section,
    onClose,
    onSuccess,
  });

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete{' '}
          <strong className="text-foreground">{section.section_name}</strong>?
        </p>
        {section.questions_count && section.questions_count > 0 ? (
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
            <p className="text-sm text-yellow-800">
              ⚠️ <strong>Warning:</strong> This section contains{' '}
              <strong>
                {section.questions_count} question
                {section.questions_count !== 1 ? 's' : ''}
              </strong>
              . All questions will be permanently deleted.
            </p>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">
            This action cannot be undone and will permanently remove this
            section from the application.
          </p>
        )}
      </div>

      <div className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={handleDelete}
          disabled={deleteSectionMutation.isPending}
        >
          {deleteSectionMutation.isPending ? 'Deleting...' : 'Delete Section'}
        </Button>
      </div>
    </div>
  );
}
